import { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PageLoading } from '@/components/ui/loading';
import { useToast } from '@/contexts/ToastContext';

export default function SettingsPage() {
  const { addToast } = useToast(); const qc = useQueryClient();
  const [settings, setSettings] = useState<Record<string, string>>({});
  const { data, isLoading } = useQuery({ queryKey: ['settings'], queryFn: async () => { const r = await api.get<{ data: any[] }>('/settings'); return r.data ?? []; } });

  useEffect(() => {
    if (data) {
      const map: Record<string, string> = {};
      data.forEach((s: any) => { map[s.key] = s.value || ''; });
      setSettings(map);
    }
  }, [data]);

  const mutation = useMutation({
    mutationFn: async () => {
      for (const [key, value] of Object.entries(settings)) {
        await api.put('/settings', { key, value });
      }
    },
    onSuccess: () => { addToast('Settings saved', 'success'); },
    onError: (e: any) => addToast(e.message, 'error'),
  });

  if (isLoading) return <PageLoading />;

  const fields = [
    { key: 'company_name', label: 'Company Name' },
    { key: 'currency', label: 'Currency' },
    { key: 'timezone', label: 'Timezone' },
    { key: 'default_shift_hours', label: 'Default Shift Hours' },
    { key: 'overtime_multiplier', label: 'Overtime Multiplier' },
    { key: 'requirement_prefix', label: 'Departmental Labour-Requirement Prefix' },
  ];

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-heading font-bold">Organization Settings</h1>
      <Card>
        <CardContent className="pt-6 space-y-4">
          {fields.map(f => (
            <div key={f.key}>
              <Label>{f.label}</Label>
              <Input value={settings[f.key] || ''} onChange={e => setSettings(prev => ({ ...prev, [f.key]: e.target.value }))} />
            </div>
          ))}
        </CardContent>
      </Card>
      <div className="flex justify-end">
        <Button onClick={() => mutation.mutate()} loading={mutation.isPending}>Save Settings</Button>
      </div>
    </div>
  );
}

